{
  "R": [0, 0, 0],
  "G": [127, 196, 254],
  "B": [255, 255, 255],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
